import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";
import * as types from "@/app/types";

export default class APIUserId extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getProducts = async (
    userId: UUID,
    { page, size }: { page?: number | null; size?: number | null } = {},
  ): Promise<types.Page<types.ProductResponse>> => {
    let res = await this._fetch({
      url: `/users/${userId}/products`,
      method: "GET",
      params: { page: page, size: size },
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
